/**
 * @fileoverview Entity Picker label list presentation component
 */
goog.declareModuleId('yext.ui.components.entitypicker.LabelList');

import {LabelItem} from '/ui/components/entitypicker/itemlist/labelitem';
import {yext} from '/ui/lib/msg';


export class LabelList extends React.Component {
  constructor(props) {
    super(props);

    this.noResultsMsg = yext.msg('There were no labels found.');
  }

  render() {
    return (
      <ul className="uep-label-list">
        {this.props.labels.length > 0
          ? this.props.labels.map(l => <LabelItem label={l} key={l.id} onClick={() => this.props.labelClickHandler(l)} />)
          : <span className="uep-no-results">{this.noResultsMsg}</span>}
      </ul>
    );
  }
}
